import { File } from "@/types/types";

export type FileSourceFilter = "uploaded" | "generated" | "meetings" | null;

export const FILE_SOURCE_FILTER_OPTIONS: {
  value: Exclude<FileSourceFilter, null>;
  label: string;
}[] = [
  { value: "uploaded", label: "Uploaded" },
  { value: "generated", label: "Generated image" },
  { value: "meetings", label: "Meetings" },
];

export function getFileSourceLabel(source: File["source"]): string {
  switch (source) {
    case "generated":
      return "Generated image";
    case "meeting_transcript":
      return "Meeting transcript";
    case "meeting_summary":
      return "Meeting summary";
    case "uploaded":
    default:
      return "Uploaded";
  }
}

export const FILE_CATEGORY_TO_SOURCE_MAP: Record<
  Exclude<FileSourceFilter, null>,
  File["source"][]
> = {
  uploaded: ["uploaded"],
  generated: ["generated"],
  meetings: ["meeting_transcript", "meeting_summary"],
};
